import styled from 'styled-components'
import { measurments } from '../utils/config'
import { Icon } from '@bm-js/atlascloud-ui'
import { LucideIconName } from '@bm-js/atlascloud-shared'

const StyledInfoBox = styled.div<{ $mw?: number; $w?: number }>`
  svg {
    width: 16px;
    height: 16px;
  }
  position: relative;
  isolation: isolate;
  .infobox-content {
    position: absolute;
    max-width: ${({ $mw }) => $mw}px;
    width: ${({ $w }) => $w}px;
    background: white;
    right: 0;
    top: 0;
    padding: 0.5rem;
    padding-right: 2rem;
    opacity: 0;
    pointer-events: none;
    border-radius: ${measurments.borderRadius}px;
    box-shadow: 2px 2px 16px rgba(0, 0, 0, 0.1);
    transition: 200ms ease-in-out;
    z-index: 11;
    .infobox-icon-inside-container {
      transition: 200ms ease-in-out;
      position: absolute;
      top: 0;
      right: 0;
    }
  }
  &:hover {
    .infobox-content {
      opacity: 1;
      pointer-events: initial;
      .infobox-icon-inside-container {
        top: 0.3rem;
        right: 0.3rem;
      }
    }
  }
`

type Props = {
  text: string
  mw?: number
  w?: number
}

const InfoBox = ({ text, mw, w }: Props) => {
  return (
    <StyledInfoBox $mw={mw} $w={w}>
      <div className='infobox-icon-container text-primary-400'>
        <Icon name={LucideIconName.CircleQuestionMark} />
      </div>
      <div className='infobox-content'>
        <div className='infobox-icon-inside-container text-primary-400'>
          <Icon name={LucideIconName.CircleQuestionMark} />
        </div>
        <p className='m0'>{text}</p>
      </div>
    </StyledInfoBox>
  )
}

export default InfoBox
